var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContactIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.25059 12.6464L16.6787 20.062C16.7761 20.1483 16.8943 20.2077 17.0216 20.2344C17.1489 20.2612 17.281 20.2544 17.4048 20.2147C17.5287 20.175 17.6401 20.1037 17.7281 20.0079C17.8161 19.9121 17.8777 19.7951 17.9068 19.6683L21.4318 4.27454C21.4614 4.14197 21.4544 4.00386 21.4116 3.87495C21.3688 3.74605 21.2918 3.63119 21.1888 3.54264C21.0858 3.45408 20.9607 3.39516 20.8268 3.37216C20.693 3.34916 20.5554 3.36294 20.4287 3.41204L3.12246 10.2089C2.42871 10.4808 2.52246 11.4933 3.25371 11.6433L8.25059 12.6464Z",
    stroke: "white",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 12.6473L21.0094 3.43164",
    stroke: "white",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4594 16.3496L9.53437 19.2746C9.43002 19.3806 9.29653 19.4531 9.15085 19.483C9.00517 19.5129 8.85388 19.4989 8.71622 19.4426C8.57856 19.3863 8.46073 19.2904 8.37772 19.167C8.2947 19.0436 8.25025 18.8983 8.25 18.7496V12.6465",
    stroke: "white",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactIcon);
export default __webpack_public_path__ + "static/media/contact-icon.74b97c332b21a009d22ee0511d52c5c8.svg";
export { ForwardRef as ReactComponent };